<template>
	<!-- TODO 可复用 -->
	<div ref="dropdownRef" class="market-dropdown">
		<div class="dropdown-trigger" @click="toggleDropdown">
			<slot
				name="title"
				:current="{
					text: currentText,
					value: value,
					option: currentOption
				}"
				:is-open="isOpen"
			>
				<span class="trigger-text">{{ currentText }}</span>
			</slot>
			<SvgIcons name="down" class="arrow" :class="{ open: isOpen }" />
		</div>

		<transition name="dropdown-fade">
			<div v-if="isOpen" class="dropdown-menu">
				<div
					v-for="option in options"
					:key="option.value"
					class="dropdown-item"
					:class="{ active: option.value === value }"
					@click="handleSelect(option)"
				>
					{{ option.text }}
				</div>
			</div>
		</transition>
	</div>
</template>

<script setup>
import { ref, computed, watch, onBeforeUnmount } from 'vue';

const props = defineProps({
	value: {
		type: String,
		default: ''
	},
	options: {
		type: Array,
		default: () => []
	}
});

const emit = defineEmits(['update:value', 'change']);

const dropdownRef = ref(null);
const isOpen = ref(false);

const currentOption = computed(() => {
	return props.options.find(opt => opt.value === props.value);
});

const currentText = computed(() => {
	return currentOption.value ? currentOption.value.text : '';
});

const toggleDropdown = () => {
	isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
	isOpen.value = false;
};

const handleSelect = option => {
	if (props.value !== option.value) {
		emit('update:value', option.value);
		emit('change', option);
	}
	closeDropdown();
};

// 点击外部关闭下拉菜单
const handleClickOutside = event => {
	if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
		closeDropdown();
	}
};

// 监听外部值变化
watch(
	() => props.value,
	() => {
		closeDropdown();
	}
);

// 监听下拉菜单状态，添加/移除全局点击监听
watch(isOpen, newVal => {
	if (newVal) {
		setTimeout(() => {
			document.addEventListener('click', handleClickOutside);
		}, 0);
	} else {
		document.removeEventListener('click', handleClickOutside);
	}
});

onBeforeUnmount(() => {
	document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="less" scoped>
@import '@/style/global.less';

.market-dropdown {
	position: relative;
	display: inline-block;

	.dropdown-trigger {
		display: flex;
		align-items: center;
		gap: 4px;
		cursor: pointer;
		user-select: none;

		.trigger-text {
			color: var(--t-secondary-info-color, #86909c);
			font-size: 13px;
			font-weight: 500;
		}

		.arrow {
			color: #86909c !important;
			transition: transform 0.3s ease;

			&.open {
				transform: rotate(180deg);
			}
		}
	}

	.dropdown-menu {
		position: absolute;
		top: calc(100% + 4px);
		left: 0;
		z-index: 999;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
		min-width: 120px;
		max-height: 300px;
		overflow-y: auto;
		padding: 2px 0;

		.dropdown-item {
			font-size: 14px;
			color: #222;
			cursor: pointer;
			transition: background-color 0.2s ease;
			position: relative;
			white-space: nowrap;
			padding: 0 16px;
			height: 42px;
			line-height: 42px;

			&.active {
				color: var(--theme-color);
			}
			& + .dropdown-item {
				.thinner-border(1px solid var(--border-normal-color), none, none, none);

				&::before {
					left: 10px;
					width: calc(200% - 40px);
				}
			}
		}
	}
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
	transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
	opacity: 0;
	transform: translateY(-8px);
}
</style>
